import type { ComponentProps, PropsWithChildren, ReactNode } from 'react'
import { AdminPageFrame } from './AdminPageFrame'

const tintedCanvasProps = { 'data-tinted-canvas': '' } as const
const embedPageProps = { 'data-embed-page': '' } as const

export const AdminTintedPage = ({ children }: PropsWithChildren) => (
  <div {...tintedCanvasProps} className='contents'>
    {children}
  </div>
)

type AdminEmbedPageProps = Omit<ComponentProps<'iframe'>, 'className'> & {
  title: string
}

export const AdminEmbedPage = ({ title, ...iframeProps }: AdminEmbedPageProps) => (
  <div {...embedPageProps} className='flex flex-1 p-2'>
    <iframe title={title} {...iframeProps} className='flex-1 rounded-2xl border-0' />
  </div>
)

type AdminLayoutProps = PropsWithChildren<{
  menu: ReactNode
  header?: ReactNode
}>

export const AdminLayout = ({ children, menu, header }: AdminLayoutProps) => (
  <div className='flex h-dvh not-print:min-w-275 flex-col bg-colorBgLayout print:h-auto'>
    {header && <header className='shrink-0 print:hidden'>{header}</header>}
    <div className='group/admin-canvas flex min-h-0 flex-1 bg-(--admin-canvas) [--admin-canvas:var(--color-colorBgLayout)] has-[[data-tinted-canvas]]:[--admin-canvas:var(--color-geekblue1)]'>
      {menu}
      {/* isolate keeps page content from painting over the app chrome, whatever z-index it sets */}
      <main className='isolate min-w-0 flex-1 not-print:overflow-auto'>
        <AdminPageFrame>{children}</AdminPageFrame>
      </main>
    </div>
  </div>
)
